export const generateAvatarFromFullName = (fullName: string): string =>
  `https://eu.ui-avatars.com/api/?name=${fullName.replace(
    ' ',
    '+',
  )}&size=91&color=1a73e8&background=f1f3f9`;
